import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from "@angular/core";

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SearchBarComponent implements OnInit {

  public t;

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/search-bar/search-bar.component.ts